import React, { useEffect, useState } from "react";
import {
  AlertCircle,
  ArrowRight,
  CarFront,
  Cog,
  Copy,
  CreditCard,
  FileCheck,
  FileJson,
  Fuel,
  Info,
  ListCheck,
  Loader,
  Loader2,
  Wrench,  Building,
  Briefcase,
  Layers,  Car,
  User,
  MapPin,
  Calendar,
  ShieldCheck,
  FileText,
  CheckCircle2,
} from "lucide-react";

import { isAlphanumeric } from "validator";
import { useService } from "../../../../context/ServiceContext";
import { showErrorToast, showSuccessToast } from "../../../../utils/toastUtils";
import { fetchProfile } from "../../../../Services/profile/profileservice";
import Seo from "../../../../Components/SeoComponent/Seo";
import Header from "../../../../Components/Header";
import { getVehicleFopDetails } from "../../../../Services/ApiTestService/apiTestService";

function VehicleFopDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [vehicleNo, setVehicleNo] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);
  const { serviceName } = useService();

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const isAlpha = (value) => {
    if (!value) return false;

    return isAlphanumeric(String(value).trim(), "en-IN", { ignore: " " });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const fetchVehicleFopDetails = async () => {
    if (!profileData) return;

    const validateVehicleNum = isAlpha(vehicleNo);

    if (!vehicleNo) {
      return setInputError("Vehicle Number is Required");
    }

    if (vehicleNo && !validateVehicleNum) {
      return setInputError(
        "⚠️ Please enter alpha numeric in Vehicle No. field",
      );
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await getVehicleFopDetails({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        vehicle_number: vehicleNo.trim()?.toUpperCase(),
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className="max-w-4xl w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-100">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
              <CarFront size={24} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800">
                {serviceName}
              </h2>
              <p className="text-sm text-slate-500">
                Verify vehicle details using the Vehicle number.
              </p>
            </div>
          </div>

          {/* Inputs */}
          <div className="mt-6  gap-6 flex justify-center items-center">
            {/* Vehicle Number */}
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <Cog size={17} className="text-blue-600" />
                Vehicle Number
              </label>

              <input
                type="text"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                placeholder="Eg: GJ0***1256"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-3 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>

            {/* Button */}
            <div className="mt-8 flex ">
              <button
                disabled={isLoading || !vehicleNo}
                onClick={fetchVehicleFopDetails}
                className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
              >
                {isLoading ? (
                  <>
                    <Loader2 size={18} className="animate-spin" />
                    Verifying...
                  </>
                ) : (
                  <>
                    Verify Vehicle
                    <ArrowRight
                      size={18}
                      className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Error */}
          {inputError && (
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-700">
              <AlertCircle size={18} />
              <span className="text-sm font-medium">{inputError}</span>
            </div>
          )}
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div className="w-full flex justify-center">
          <div className="bg-green-100 max-w-3xl border border-green-400 text-green-700 p-5 mt-12 rounded-2xl">
            <h3 className="font-bold flex items-center justify-start gap-2 text-lg mb-2">
              <Info /> Important Instructions{" "}
              <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid Vehicle Number. Clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including contact details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1  gap-6 mt-10 w-full max-w-6xl">
          

            <div className="bg-gray-200 p-2 rounded-md">
              <h2 className="text-2xl flex items-center justify-center gap-2 font-bold text-blue-500 mb-1">
                <ListCheck />
                Insurance Data
              </h2>

              {response?.status?.code === 200 && response?.data && (
               <VehicleDetailsCard response={response}/>
              )}
            </div>

              {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-2" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default VehicleFopDetails;


 function VehicleDetailsCard({ response }) {
  const [activeTab, setActiveTab] = useState("specs");
  const data = response?.data;

  if (response?.status?.code !== 200 || !data) {
    return null;
  }

  const {
    registrationNumber,
    state,
    rtoOffice,
    ownerDetails,
    registrationDetails,
    vehicleDetails,
    insuranceDetails,
    puccDetails,
    fitnessDetails,
    permitDetails,
    hypothecationDetails,
    feeHistory = [],
    roadTaxHistory = [],
  } = data;

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 space-y-6 bg-slate-50 min-h-screen text-slate-800">
      {/* 1. Header Banner */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200/80 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 bg-blue-600 rounded-2xl flex items-center justify-center text-white shadow-md shadow-blue-500/20">
            <Car size={32} />
          </div>
          <div>
            <div className="flex items-center gap-3">
              <span className="bg-amber-100 text-amber-900 border border-amber-300 font-mono font-bold text-lg px-3 py-0.5 rounded-md tracking-wider">
                {registrationNumber}
              </span>
              <span className="bg-emerald-100 text-emerald-800 text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
                <CheckCircle2 size={12} /> {registrationDetails?.registrationType || "ACTIVE"}
              </span>
            </div>
            <h1 className="text-xl font-bold text-slate-900 mt-1">
              {vehicleDetails?.manufacturer} {vehicleDetails?.model}
            </h1>
            <p className="text-sm text-slate-500 flex items-center gap-1 mt-0.5">
              <MapPin size={14} className="text-slate-400" /> {rtoOffice}, {state}
            </p>
          </div>
        </div>

        {/* Quick Spec Highlights */}
        <div className="flex flex-wrap gap-2 text-xs font-medium">
          <span className="bg-slate-100 text-slate-700 px-3 py-1.5 rounded-lg border border-slate-200 flex items-center gap-1.5">
            <Fuel size={14} className="text-blue-600" /> {vehicleDetails?.fuelType}
          </span>
          <span className="bg-slate-100 text-slate-700 px-3 py-1.5 rounded-lg border border-slate-200 flex items-center gap-1.5">
            <Car size={14} className="text-blue-600" /> {vehicleDetails?.vehicleClass}
          </span>
          <span className="bg-slate-100 text-slate-700 px-3 py-1.5 rounded-lg border border-slate-200 flex items-center gap-1.5">
            <Calendar size={14} className="text-blue-600" /> Reg: {registrationDetails?.registrationDate}
          </span>
        </div>
      </div>

      {/* 2. Key Validity & Status Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Fitness */}
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start gap-3">
          <div className="p-2.5 bg-emerald-50 text-emerald-600 rounded-lg">
            <Wrench size={20} />
          </div>
          <div>
            <p className="text-xs text-slate-500 font-medium">Fitness Valid Upto</p>
            <p className="text-sm font-semibold text-slate-900 mt-0.5">
              {fitnessDetails?.fitnessValidUpto || "N/A"}
            </p>
            <span className="text-[11px] font-medium text-emerald-600 mt-1 block">
              Result: {fitnessDetails?.result || "N/A"}
            </span>
          </div>
        </div>

        {/* Insurance */}
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start gap-3">
          <div className="p-2.5 bg-blue-50 text-blue-600 rounded-lg">
            <ShieldCheck size={20} />
          </div>
          <div>
            <p className="text-xs text-slate-500 font-medium">Insurance Expiry</p>
            <p className="text-sm font-semibold text-slate-900 mt-0.5">
              {insuranceDetails?.insuranceExpiryDate || "N/A"}
            </p>
            <span className="text-[11px] text-slate-500 truncate block max-w-[140px]" title={insuranceDetails?.company}>
              {insuranceDetails?.company}
            </span>
          </div>
        </div>

        {/* PUCC */}
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start gap-3">
          <div className="p-2.5 bg-indigo-50 text-indigo-600 rounded-lg">
            <FileCheck size={20} />
          </div>
          <div>
            <p className="text-xs text-slate-500 font-medium">PUCC Valid Upto</p>
            <p className="text-sm font-semibold text-slate-900 mt-0.5">
              {puccDetails?.puccUpto || "N/A"}
            </p>
            <span className="text-[11px] text-slate-500 block">No: {puccDetails?.puccNo}</span>
          </div>
        </div>

        {/* Permit */}
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start gap-3">
          <div className="p-2.5 bg-purple-50 text-purple-600 rounded-lg">
            <FileText size={20} />
          </div>
          <div>
            <p className="text-xs text-slate-500 font-medium">Permit Valid Upto</p>
            <p className="text-sm font-semibold text-slate-900 mt-0.5">
              {permitDetails?.validUpto || "N/A"}
            </p>
            <span className="text-[11px] text-purple-600 font-medium block">
              {permitDetails?.permitCategory || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* 3. Detail Sections Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Owner Details Card */}
        <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-slate-100 text-slate-900 font-semibold">
            <User size={18} className="text-blue-600" />
            <h2>Owner Information</h2>
          </div>
          <div className="space-y-3 text-sm">
            <div>
              <p className="text-xs text-slate-400">Full Name</p>
              <p className="font-semibold text-slate-800">{ownerDetails?.ownerName}</p>
            </div>
            <div>
              <p className="text-xs text-slate-400">Guardian Name</p>
              <p className="text-slate-700">{ownerDetails?.guardianName}</p>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <p className="text-xs text-slate-400">Ownership Type</p>
                <p className="text-slate-700">{ownerDetails?.ownershipType}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Mobile</p>
                <p className="text-slate-700">{ownerDetails?.mobileNumber}</p>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-400">Address</p>
              <p className="text-slate-700 text-xs mt-0.5">
                {ownerDetails?.address?.street}, {ownerDetails?.address?.city},{" "}
                {ownerDetails?.address?.landmark}, {ownerDetails?.address?.district},{" "}
                {ownerDetails?.address?.state} - {ownerDetails?.address?.pinCode}
              </p>
            </div>
          </div>
        </div>

        {/* Hypothecation / Financing Card */}
        <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-slate-100 text-slate-900 font-semibold">
            <Building size={18} className="text-blue-600" />
            <h2>Financing Details</h2>
          </div>
          {hypothecationDetails?.financerName ? (
            <div className="space-y-3 text-sm">
              <div>
                <p className="text-xs text-slate-400">Status</p>
                <span className="inline-block bg-amber-50 text-amber-700 text-xs px-2.5 py-0.5 rounded-full font-medium border border-amber-200 mt-1">
                  {hypothecationDetails?.type}
                </span>
              </div>
              <div>
                <p className="text-xs text-slate-400">Financer Name</p>
                <p className="font-semibold text-slate-800">{hypothecationDetails?.financerName}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Branch Address</p>
                <p className="text-slate-700 text-xs">{hypothecationDetails?.financerAddress}</p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-slate-400 italic">No Hypothecation Details Found</p>
          )}
        </div>

        {/* Registration Meta Card */}
        <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-slate-100 text-slate-900 font-semibold">
            <Briefcase size={18} className="text-blue-600" />
            <h2>Registration Meta</h2>
          </div>
          <div className="space-y-3 text-sm">
            <div className="grid grid-cols-2 gap-2">
              <div>
                <p className="text-xs text-slate-400">Purchase Date</p>
                <p className="text-slate-700">{registrationDetails?.purchaseDate}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Valid Upto</p>
                <p className="text-slate-700">{registrationDetails?.registrationValidUpto}</p>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-400">Dealer</p>
              <p className="text-slate-700">{vehicleDetails?.dealer}</p>
            </div>
            <div>
              <p className="text-xs text-slate-400">Emission Norms</p>
              <p className="text-slate-700 font-medium">{vehicleDetails?.emissionNorms}</p>
            </div>
          </div>
        </div>
      </div>

      {/* 4. Tabbed Detail Views (Specs & History) */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        {/* Navigation Tabs */}
        <div className="flex border-b border-slate-200 bg-slate-50/50 overflow-x-auto">
          <button
            onClick={() => setActiveTab("specs")}
            className={`px-5 py-3.5 text-sm font-semibold flex items-center gap-2 border-b-2 whitespace-nowrap transition-colors ${
              activeTab === "specs"
                ? "border-blue-600 text-blue-600 bg-white"
                : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            <Layers size={16} /> Vehicle Specifications
          </button>
          <button
            onClick={() => setActiveTab("fees")}
            className={`px-5 py-3.5 text-sm font-semibold flex items-center gap-2 border-b-2 whitespace-nowrap transition-colors ${
              activeTab === "fees"
                ? "border-blue-600 text-blue-600 bg-white"
                : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            <CreditCard size={16} /> Fee Receipts ({feeHistory.length})
          </button>
          <button
            onClick={() => setActiveTab("taxes")}
            className={`px-5 py-3.5 text-sm font-semibold flex items-center gap-2 border-b-2 whitespace-nowrap transition-colors ${
              activeTab === "taxes"
                ? "border-blue-600 text-blue-600 bg-white"
                : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            <FileText size={16} /> Road Tax History ({roadTaxHistory.length})
          </button>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {/* Specs Tab */}
          {activeTab === "specs" && (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 text-sm">
              <div>
                <p className="text-xs text-slate-400">Chassis Number</p>
                <p className="font-mono font-medium text-slate-800">{vehicleDetails?.chassisNumber}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Engine Number</p>
                <p className="font-mono font-medium text-slate-800">{vehicleDetails?.engineNumber}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Engine Capacity</p>
                <p className="text-slate-800">{vehicleDetails?.engineCapacity} cc ({vehicleDetails?.cylinders} Cylinders)</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Horse Power</p>
                <p className="text-slate-800">{vehicleDetails?.horsePower} BHP</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Color</p>
                <p className="text-slate-800">{vehicleDetails?.color}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Seating Capacity</p>
                <p className="text-slate-800">{vehicleDetails?.seatingCapacity} Seats</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Unladen / Laden Weight</p>
                <p className="text-slate-800">{vehicleDetails?.unladenWeight} kg / {vehicleDetails?.ladenWeight} kg</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Dimensions (L × W × H)</p>
                <p className="text-slate-800">
                  {vehicleDetails?.dimensions?.length} x {vehicleDetails?.dimensions?.width} x {vehicleDetails?.dimensions?.height} mm
                </p>
              </div>
            </div>
          )}

          {/* Fee History Tab */}
          {activeTab === "fees" && (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                    <th className="py-3 px-4">Receipt No</th>
                    <th className="py-3 px-4">Fee Type</th>
                    <th className="py-3 px-4">Date</th>
                    <th className="py-3 px-4">Mode</th>
                    <th className="py-3 px-4 text-right">Amount</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {feeHistory.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80">
                      <td className="py-3 px-4 font-mono text-xs">{item.receiptNumber}</td>
                      <td className="py-3 px-4 font-medium text-slate-800">{item.feeType}</td>
                      <td className="py-3 px-4 text-slate-500 text-xs">{item.receiptDate}</td>
                      <td className="py-3 px-4 text-slate-500 text-xs">{item.collectionMode}</td>
                      <td className="py-3 px-4 text-right font-semibold text-slate-800">₹{item.feeAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Road Tax History Tab */}
          {activeTab === "taxes" && (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                    <th className="py-3 px-4">Tax Type</th>
                    <th className="py-3 px-4">Tax From</th>
                    <th className="py-3 px-4">Mode</th>
                    <th className="py-3 px-4">Challan Date</th>
                    <th className="py-3 px-4 text-right">Tax Amount</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {roadTaxHistory.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80">
                      <td className="py-3 px-4 font-medium text-slate-800">{item.taxType}</td>
                      <td className="py-3 px-4 text-slate-600">{item.taxFrom}</td>
                      <td className="py-3 px-4 text-slate-500 text-xs">{item.taxMode}</td>
                      <td className="py-3 px-4 text-slate-500 text-xs">{item.challanDate}</td>
                      <td className="py-3 px-4 text-right font-semibold text-slate-800">₹{item.taxAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}